import React from "react";
import { useAppContext } from "../../context";
import { isPME_TEAM } from "../../helper";
import { WrapperPage } from "../../components/shared/WrapperPage";
import EtsyMetric from "../../components/etsy-metric";

export default function EtsyMetricPage() {
    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);

    return (
        <WrapperPage>
            {isPME ? (
                <EtsyMetric />
            ) : (
                <p>You don't have privilege to access this route</p>
            )}
        </WrapperPage>
    );
}
